import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setRuleTab, setRuleTree, setSearchTree, setSearchTerm, setSelectedRule } from '../../redux/rulesSlice';
import { initializeAuth, getSearchResults } from '../../services/apiService';
import { useMsal } from "@azure/msal-react";
import DropDownSearchType from '../layout/DropDownSearchType';

const SearchRules = () => {
  const { instance, accounts } = useMsal();
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(false);
  const { dbSrc, searchType, ruleTab } = useSelector(state => state.rules);
  const resultsBlue = ruleTab === 'search' ? 'headerBlue borderBlue' : '';
  const ruleBlue = ruleTab === 'rule' ? 'headerBlue borderBlue' : '';
  
  useEffect(() => {
    const resetSearch = async () => {
        dispatch(setSelectedRule({}));     
        dispatch(setSearchTree([]));
        setSearchText('');
    };
    resetSearch();
  }, [dbSrc]);

  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  }

  const handleSearch = async () => {
    if (searchText.trim()) {
      setLoading(true);
      dispatch(setRuleTab('search'));
      dispatch(setRuleTree([]));
      dispatch(setSelectedRule({}));
      dispatch(setSearchTree([]));
      await initializeAuth(instance, accounts);
      try {
        const response = await getSearchResults(searchText.trim(), searchType);
        console.log("Fetched Tree:", response);
        dispatch(setSearchTree(response));
        dispatch(setSearchTerm(searchText.trim()));
      } catch (error) {
        console.error("Failed to fetch tree:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeRuleTab = (tab) => {
    if (ruleTab !== tab)
    {
      dispatch(setRuleTab(tab));
    }
  };

return (
    <div className="w-full">
        <div className="flex w-full space-x-2 mb-2">
            <DropDownSearchType />
            <input
                type="text"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onKeyUp={handleKeyUp}
                className="flex-1 border p-2 rounded"
                placeholder="Enter rule text..."
            />
            <button
              onClick={handleSearch}
              className="bg-blue-500 text-white px-4 rounded hover:bg-blue-600"
              disabled={loading}
            >
              {loading ? "Searching..." : "Search"}
            </button>
        </div>
      <button onClick={() => handleChangeRuleTab('search')} className={`px-4 text-left  ${resultsBlue}`}>Results</button>
      <button onClick={() => handleChangeRuleTab('rule')} className={`px-4 text-left  ${ruleBlue}`}>Rule</button>
    </div>
);
};

export default SearchRules;
